import CityCard from 'modules/_common/CityCard';
import React from 'react'
import styled from 'styled-components'
import breakpoints from 'theme/breakpoints'
import { Row } from 'styled/alignment/Row';
import { useNavigate } from 'react-router-dom';
import paths from 'routes/paths';

export default function CitiesList() {
    const navigate = useNavigate();
    const cities = [
        { name: 'Pelotas, RS', url: '/assets/images/cities/pelotas-rs.png' },
        { name: 'Porto Alegre, RS', url: '/assets/images/cities/porto-alegre-rs.jpg' },
        { name: 'Gramado, RS', url: '/assets/images/cities/gramado-rs.jpg' },
        { name: 'São Paulo, SP', url: '/assets/images/cities/sao-paulo-sp.jpg' },
        { name: 'Florianópolis, SC', url: '/assets/images/cities/florianopolis-sc.jpg' },
    ];

    function handleCityClick(cityFullName) {
        const slug = cityFullName
            .toLowerCase()
            .replace(/\s*,\s*/g, '-')
            .replace(/\s+/g, '-')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '');
        navigate(`${paths.events.search}?city=${encodeURIComponent(slug)}`);
    }

    return (
        <Container>
            {cities.map(el => (
                <CityCard
                    data={el}
                    key={el.name}
                    onClick={() => handleCityClick(el.name)}
                />
            ))}
        </Container>
    )
}

const Container = styled(Row)`
    width: 100%;
    gap: 10px;

    @media screen and (max-width: calc(${breakpoints.lg} - 1px)) {
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 8px;

        & > div {
            flex-shrink: 0;
            width: 150px;
            height: 160px;
        }
    }

    @media screen and (min-width: ${breakpoints.lg}) {
        flex-wrap: wrap;
    }
`;
